var curry = require('curry');
var reverse = require('../reverse.js');
var scrollTo = require('../scrollTo.js');
var ease = require('ease-component');

var scrollToEl = function(el) {
	scrollTo(
		el.getBoundingClientRect().top + window.scrollY - 20,
		300,
		ease.inCube
	);
};

var onYearClick = function(root, el) {
	scrollToEl(root.querySelector(`.news__item[data-year="${el.dataset.year}"]`));
};

var onMonthClick = function(root, el) {
	scrollToEl(root.querySelector(`.news__item[data-year="${el.dataset.year}"][data-month="${el.dataset.month}"]`));
};

var onClick = curry(function(root, evt) {
	if(evt.target.classList.contains('news-line__month')) {
		onMonthClick(root, evt.target);
	} else {
		onYearClick(root, evt.target);
	}
});

var buildScale = function(scale, item) {
	var d = item.dataset;
	scale[d.year] = scale[d.year] || [];

	if(scale[d.year].indexOf(d.month) === -1) {
		scale[d.year].push(d.month);
	}

	return scale;
};

var buildMonth = curry(function(year, monthName) {
	var monthEl = document.createElement('li');
	monthEl.className = 'news-line__month';
	monthEl.textContent = monthName;
	monthEl.dataset.year = year;
	monthEl.dataset.month = monthName;

	return monthEl;
});

var buildYear = curry(function(years, year) {
	var yearEl = document.createElement('li');
	yearEl.className = 'news-line__year';
	yearEl.textContent = year;

	var monthsEl = document.createElement('ul');
	monthsEl.className = 'news-line__months';

	yearEl.appendChild(monthsEl);
	years[year].map(buildMonth(year)).forEach(appendTo(monthsEl));
	yearEl.dataset.year = year;

	return yearEl;
});

var appendTo = curry(function(cont, el) {
	cont.appendChild(el);
});

var buildLine = function(items, line, root) {
	var scale = Array.prototype.reduce.call(items, buildScale, {});
	line.innerHTML = '';
	line.addEventListener('click', onClick(root));
	reverse(Object.keys(scale)).map(buildYear(scale)).forEach(appendTo(line));
};

module.exports = function(root) {
	buildLine(root.querySelectorAll('.news__item'), root.querySelector('.news-line'), root);
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/news/list.js
 **/